import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IonicModule } from 'ionic-angular';

import { TabetakotoaruViewComponent } from './tabetakotoaru-view/tabetakotoaru-view';
import { TabetakotoaruRinyushokuViewComponent } from './tabetakotoaru-rinyushoku-view/tabetakotoaru-rinyushoku-view';

@NgModule({
    declarations: [
        TabetakotoaruViewComponent,
        TabetakotoaruRinyushokuViewComponent,
    ],
    imports: [
        IonicModule,
        FormsModule
    ],
    exports: [
        TabetakotoaruViewComponent,
        TabetakotoaruRinyushokuViewComponent,
    ]
})
export class ComponentsModule {}



// WEBPACK FOOTER //
// ./src/components/components.module.ts